import React from 'react';
import PatientForm from './components/PatientForm';

function App() {
  return (
    <div className="App">
      <PatientForm />
    </div>
  );
}

export default App;
